import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { base_url } from "../../utils/AxiosConfig";
import dayjs from "dayjs";
import { FaRegEdit } from "react-icons/fa";
import { MdOutlineDelete } from "react-icons/md";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";
import { base_url_image_post_api } from "../../utils/ImageCreationAPI";
import { base_url_image_view_api } from "../../utils/ImageViewingAPI";
import { HiPaperClip, HiDownload } from "react-icons/hi";

const DocumentExpiry = () => {
  const fileInputRef = useRef(null);
  const [userDataArray, setUserDataArray] = useState([]);
  const [data, setData] = useState([]);
  const [isDelete, setIsDelete] = useState(false);
  const [isDeleteDoc, setIsDeleteDoc] = useState(null);
  const [selectedFiles, setSelectedFiles] = useState({});
  const [isEdit, setIsEdit] = useState(false);
  const [editDoc, setEditDoc] = useState(null);
  const [file, setFile] = useState(null);
  const [editDocumentName, setEditDocumentName] = useState("");
  const [editExpiryDate, setEditExpiryDate] = useState("");
  const [editRemarks, setEditRemarks] = useState("");
  const [editDocType, setEditDocType] = useState("");
  const [error, setError] = useState("");
  // const [userDocHistory, setUserDocHistory] = useState([]);
  const [userDocHistory, setUserDocHistory] = useState({});
  const [loginUser, setLoginUser] = useState("");
  const [docPath, setDocPath] = useState("");
  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "success",
  });

  useEffect(() => {
    fetchData();
    fetchDocumentList();
  }, []);

  const fetchData = async () => {
    try {
      const storedUserDataArray = localStorage.getItem("BondTimeLoginUserData");
      const parsedUserDataArray = JSON.parse(storedUserDataArray) || [];

      setUserDataArray(parsedUserDataArray);

      setLoginUser(
        parsedUserDataArray && parsedUserDataArray[0].salesman_name.trim(),
      );
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    if (loginUser) {
      fetchDocPath();
    }
  }, [loginUser]);

  const fetchDocumentList = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    const companyCode = storedUserDataArray?.[0]?.cmpcode || "";
    try {
      const response = await axios.get(
        `${base_url}/api/CpaysCount/${companyCode}/COMPANYDOCS/-/-`,
      );
      const docRecords = response.data;
      console.log("docRecords:", docRecords);
      setData(docRecords);
      // fetchDocData()
      docRecords.forEach((doc) => {
        fetchDocData(doc.docid);
      });
    } catch (err) {
      console.log("Documents Fetching Error", err);
    }
  };

  const handleDelete = async (doc) => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

    const companyCode = storedUserDataArray?.[0]?.cmpcode || "";
    const userName = storedUserDataArray?.[0]?.userid || "admin";

    try {
      const payload = [
        {
          CmpCode: companyCode,
          mode: "DELETE",
          docid: doc.docid,
          deptno: doc.deptno,
          docname: "",
          doctype: "",
          exp_date: doc.exp_date || "",
          remarks: "",
          updDate: new Date().toISOString(),
          updBy: userName,
        },
      ];

      await axios.post(`${base_url}/api/CompanyDocsReg`, payload);

      // remove deleted row from UI
      setData((prev) => prev.filter((item) => item.docId !== doc.docid));
      handleClose();
      console.log("Document deleted successfully");
      setSnackbar({
        open: true,
        message: "Document deleted successfully",
        severity: "success",
      });
    } catch (err) {
      console.log("Delete Error", err);
      handleClose();
      setSnackbar({
        open: true,
        message: "Document deletion failed",
        severity: "error",
      });
    }
  };

  const handleEditClick = (doc) => {
    setEditDoc(doc);

    setEditDocumentName(doc?.Document || "");
    setEditExpiryDate(
      doc?.exp_date ? dayjs(doc.exp_date).format("YYYY-MM-DD") : "",
    );
    setEditRemarks(doc?.remarks || "");
    setEditDocType(doc?.doctype || "");

    setIsEdit(true);
  };

  const handleDeleteClick = (doc) => {
    console.log("Delete Clicked!");
    setIsDelete(true);
    setIsDeleteDoc(doc);
  };

  const handleClose = () => {
    setIsDelete(false);
  };

  const handleEditClose = () => {
    setIsEdit(false);
    setEditDoc(null);
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({
      ...prev,
      open: false,
    }));
  };

  const handleUpdateDocument = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

    const companyCode = storedUserDataArray?.[0]?.cmpcode || "";
    const userName = storedUserDataArray?.[0]?.userid || "admin";

    try {
      const payload = [
        {
          CmpCode: companyCode,
          mode: "EDIT",
          docid: editDoc?.docid,
          deptno: editDoc?.deptno || "",
          docname: editDocumentName,
          doctype: editDocType,
          exp_date: editExpiryDate
            ? new Date(editExpiryDate).toISOString()
            : null,
          remarks: editRemarks,
          updDate: new Date().toISOString(),
          updBy: userName,
        },
      ];

      await axios.post(`${base_url}/api/CompanyDocsReg`, payload);

      fetchDocumentList();

      setIsEdit(false);

      console.log("Document updated successfully");
    } catch (err) {
      console.log("Update Error", err);
    }
  };

  // const handleFileChange = (e) => {
  //   const selectedFile = e.target.files[0];

  //   if (!selectedFile) return;

  //   const allowedTypes = [
  //     "application/pdf",
  //     "application/msword",
  //     "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  //     "application/vnd.ms-excel",
  //     "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  //     "text/plain",
  //   ];

  //   if (!allowedTypes.includes(selectedFile.type)) {
  //     setError("Invalid file type");
  //     setFile(null);
  //     return;
  //   }

  //   if (selectedFile.size > 5 * 1024 * 1024) {
  //     setError("File must be less than 5MB");
  //     setFile(null);
  //     return;
  //   }

  //   setError("");
  //   setFile(selectedFile);
  // };

  const handleFileChange = (e, docId) => {
    const selectedFile = e.target.files[0];

    if (!selectedFile) return;

    setSelectedFiles((prev) => ({
      ...prev,
      [docId]: selectedFile,
    }));
  };

  const uploadDocumentFileAPI = async (doc) => {
    console.log("Doc data to be uploaded!:", doc);

    const selectedFile = selectedFiles[doc.docid];

    if (!selectedFile) {
      setSnackbar({
        open: true,
        message: "No file selected",
        severity: "warning",
      });

      return;
    }

    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];

    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }

    try {
      const formData = new FormData();

      formData.append("DOC_CODE", doc.docid);
      formData.append("DOC_TYPE", "DOCIMAGE");

      // IMPORTANT
      formData.append("file", selectedFile, selectedFile.name);

      formData.append("cmpcode", companyCode);
      formData.append("IMGBASE64", "XX");

      let postEmpImagePath = localStorage.getItem("PostEmpImagePath");

      let basePath = postEmpImagePath.replace(/['"]+/g, "").trim();

      if (!basePath.endsWith("\\")) {
        basePath += "\\";
      }

      const fullPath = `${basePath}BONDTIME_DOC_IMG\\`;

      formData.append("IMAGEPATH", fullPath);

      const response = await axios.post(
        `${base_url_image_post_api}/api/Image/upload`,
        formData,
      );

      console.log("Response From document file upload:", response.data);

      if (response.status === 200) {
        setSnackbar({
          open: true,
          message: "Document file uploaded successfully",
          severity: "success",
        });

        // remove uploaded file from state
        setSelectedFiles((prev) => {
          const updated = { ...prev };

          delete updated[doc.docid];

          return updated;
        });

        fetchDocData(doc.docid);
      }
    } catch (error) {
      console.error("Error uploading data:", error);

      setSnackbar({
        open: true,
        message: "Some error occurred while uploading file",
        severity: "error",
      });
    }
  };

  const fetchDocPath = async () => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }
    try {
      const response = await axios.get(
        `${base_url}/api/MasterCount/${companyCode}/IMAGEPATH/${loginUser}/DOCIMAGE`,
      );

      if (response.status === 200) {
        console.log("fetchDocPath response:::", response.data);
        setDocPath(response.data);
      }
    } catch (error) {
      console.log("fetchDocPathErr", error);
    }
  };

  const fetchDocData = async (empId) => {
    const storedUserDataArray =
      JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
    let companyCode = null;

    if (storedUserDataArray) {
      companyCode = storedUserDataArray[0].cmpcode;
    }
    try {
      const response = await axios.get(
        `${base_url}/api/cpayscount/${companyCode}/image/${empId}/DOCIMAGE`,
      );

      if (response.status === 200) {
        // setUserDocHistory(response.data);
        setUserDocHistory((prev) => ({
          ...prev,
          [empId]: response.data,
        }));
      }
    } catch (error) {
      console.log("fetchDocDataErr", error);
    }
  };

  const handleHistoryDocClick = (fileName) => {
    try {
      console.log(
        `base URL::,${base_url_image_view_api}/BONDTIME_DOC_IMG/${fileName}`,
      );

      const fileURL = `${base_url_image_view_api}/BONDTIME_DOC_IMG/${fileName}`;
      window.open(fileURL, "_blank"); // Opens the PDF in a new tab
    } catch (error) {
      console.log("handleHistoryDocClickErr", error);
    }
  };

  console.log("userDocHistory:", userDocHistory);

  return (
    <div>
      <div className="flex justify-left items-center mb-6">
        <div className="w-1 h-8 bg-gradient-to-r from-[#2663EB] to-blue-400 rounded-full  mr-2"></div>
        <h6 className="text-xl font-bold text-gray-900 flex items-center gap-4">
          <span className="bg-gradient-to-r from-[#2663EB] to-blue-600 bg-clip-text text-transparent">
            DOCUMENT EXPIRY
          </span>
        </h6>
      </div>
      <div className="max-h-[400px] overflow-auto border rounded-md">
        <table className="min-w-full text-xs">
          <thead className="sticky top-0 bg-[#2663EB] text-white">
            <tr>
              <th className="px-2 py-2 font-normal">Doc ID</th>
              <th className="px-2 py-2 font-normal">Name</th>
              <th className="px-2 py-2 font-normal">Expiry Date</th>
              {/* <th className="px-2 py-2 font-normal">Days of Expiry</th> */}
              <th className="px-2 py-2 font-normal">Remarks</th>
              <th className="px-2 py-2 font-normal">File</th>
              <th className="px-2 py-2 font-normal">Actions</th>
            </tr>
          </thead>
          <tbody className="text-gray-700">
            {data?.map((d, i) => {
              return (
                <tr key={i} className={`cursor-pointer hover:bg-gray-50`}>
                  <td className="px-2 py-2 border">{d?.docid}</td>
                  <td className="px-2 py-2 border">{d?.Document}</td>
                  <td className="px-2 py-2 border">
                    {dayjs(d?.exp_date).format("YYYY-MM-DD") || "-"}
                  </td>
                  <td className="px-2 py-2 border">{d?.remarks}</td>
                  <td className="border px-2 py-2">
                    <div className="space-y-2">
                      {/* Existing Files */}
                      {userDocHistory[d.docid]?.map((item, index) => {
                        const fileName = item.Imagepath?.split(/[/\\]/).pop();

                        return (
                          <button
                            key={`${d.docid}-${index}`}
                            onClick={() => handleHistoryDocClick(fileName)}
                            className="text-sm text-blue-600 hover:underline block text-left"
                          >
                            {fileName}
                          </button>
                        );
                      })}

                      {/* Upload Section ALWAYS visible */}
                      <div className="flex items-center gap-2 rounded-lg p-1 bg-gray-50 border">
                        {/* File Name */}
                        <span className="text-xs text-gray-600 truncate flex-1">
                          {selectedFiles[d.docid]?.name || "No file selected"}
                        </span>

                        {/* Choose File */}
                        <label
                          htmlFor={`file-upload-${d.docid}`}
                          className="flex items-center gap-1 px-3 py-1.5 text-xs bg-green-500 text-white rounded hover:bg-green-600 transition cursor-pointer"
                        >
                          <HiPaperClip className="text-sm" />
                          Choose
                        </label>

                        {/* Upload Button */}
                        <button
                          type="button"
                          onClick={() => uploadDocumentFileAPI(d)}
                          disabled={!selectedFiles[d.docid]}
                          className={`px-3 py-1.5 text-xs rounded text-white transition
        ${
          selectedFiles[d.docid]
            ? "bg-blue-500 hover:bg-blue-600"
            : "bg-gray-400 cursor-not-allowed"
        }`}
                        >
                          Upload
                        </button>
                      </div>

                      {/* Hidden Input */}
                      <input
                        id={`file-upload-${d.docid}`}
                        type="file"
                        accept=".pdf,.doc,.docx,.xls,.xlsx,.txt"
                        onChange={(e) => handleFileChange(e, d.docid)}
                        className="hidden"
                      />
                    </div>
                  </td>

                  <td className="px-2 py-2 border ">
                    {/* DELETE */}
                    <div className="flex justify-center items-center gap-2 ">
                      <button
                        onClick={() => handleDeleteClick(d)}
                        className="p-1 bg-red-500 hover:bg-red-600 text-white rounded text-xl"
                      >
                        <MdOutlineDelete />
                      </button>

                      {/* EDIT */}
                      <button
                        onClick={() => handleEditClick(d)}
                        className="p-1 bg-blue-500 hover:bg-blue-600 text-white rounded text-lg"
                      >
                        <FaRegEdit />
                      </button>
                    </div>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>

      {/*  */}
      {isDelete && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white w-[400px] rounded-xl shadow-lg overflow-hidden">
            {/* Header */}
            <div className="flex justify-between items-center border-b px-6 py-4 bg-[#2663EB]">
              <h2 className="text-lg font-semibold text-white">
                Delete Document
              </h2>
              <button
                onClick={handleClose}
                className="text-white hover:text-red-600 text-2xl font-bold"
              >
                ×
              </button>
            </div>

            {/* Body */}
            <div className="p-8 text-center">
              <p className="text-gray-700 mb-8 text-lg">
                Are you sure to delete document {isDeleteDoc.docid} ?
                <br />
                {/* <span className="font-bold text-red-600">{deleteCatName}</span> ? */}
              </p>

              <div className="flex items-center justify-center gap-5">
                <button
                  onClick={handleClose}
                  className=" px-3 py-2.5 bg-gray-200 hover:bg-gray-300 text-gray-800 font-medium rounded-lg transition"
                >
                  Cancel
                </button>

                <button
                  onClick={() => handleDelete(isDeleteDoc)}
                  className="px-3 py-2.5 bg-red-600 hover:bg-red-700 text-white font-medium rounded-lg transition shadow-sm"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {isEdit && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
          <div className="bg-white w-[450px] rounded-xl shadow-lg overflow-hidden">
            {/* Header */}
            <div className="flex justify-between items-center border-b px-6 py-4 bg-[#2663EB]">
              <h2 className="text-lg font-semibold text-white">
                Edit Document
              </h2>

              <button
                onClick={handleEditClose}
                className="text-white hover:text-red-600 text-2xl font-bold"
              >
                ×
              </button>
            </div>

            {/* Body */}
            <div className="p-6 space-y-4">
              {/* Document Name */}
              <div>
                <label className="text-sm text-gray-600">Document Name</label>

                <input
                  type="text"
                  value={editDocumentName}
                  onChange={(e) => setEditDocumentName(e.target.value)}
                  className="w-full border rounded px-3 py-2 mt-1"
                />
              </div>

              {/* Document Type */}
              <div>
                <label className="text-sm text-gray-600">Document Type</label>

                <input
                  type="text"
                  value={editDocType}
                  onChange={(e) => setEditDocType(e.target.value)}
                  className="w-full border rounded px-3 py-2 mt-1"
                />
              </div>

              {/* Expiry Date */}
              <div>
                <label className="text-sm text-gray-600">Expiry Date</label>

                <input
                  type="date"
                  value={editExpiryDate}
                  onChange={(e) => setEditExpiryDate(e.target.value)}
                  className="w-full border rounded px-3 py-2 mt-1"
                />
              </div>

              {/* Remarks */}
              <div>
                <label className="text-sm text-gray-600">Remarks</label>

                <textarea
                  value={editRemarks}
                  onChange={(e) => setEditRemarks(e.target.value)}
                  className="w-full border rounded px-3 py-2 mt-1"
                  rows={3}
                />
              </div>

              {/* Footer */}
              <div className="flex justify-end gap-3 pt-2">
                <button
                  onClick={handleEditClose}
                  className="px-4 py-2 bg-gray-200 hover:bg-gray-300 rounded"
                >
                  Cancel
                </button>

                <button
                  onClick={handleUpdateDocument}
                  className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded"
                >
                  Update
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/*  */}
      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert
          onClose={handleCloseSnackbar}
          severity={snackbar.severity}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default DocumentExpiry;
